import $ from 'jquery';
import InView from 'inview';
import imagesLoaded from 'imagesloaded';
import * as basicLightbox from 'basiclightbox'
import slick from 'slick-carousel';
import {cookies} from 'commons/cookies';
import {header} from 'structure/header';
import {layout} from 'commons/layout';
import {scroll} from 'commons/scroll';
import {forms} from 'commons/forms';
import {modules} from 'modules/modules';
import {blog} from 'commons/blog';
import {video} from 'commons/video';

cookies($);
layout($, imagesLoaded);
header($);
scroll($, InView);
forms($);
modules($, slick);
blog($, InView);
video($, basicLightbox);
